export class ConfigService {
  private readonly BASE_CONFIG = `${import.meta.env.VITE_NOVULO_URL}`;
  private readonly API_URL = `${this.BASE_CONFIG}${import.meta.env.VITE_NOVULO_API_PATH}/broker`;
  private readonly CMS_URL = `${this.BASE_CONFIG}${import.meta.env.VITE_NOVULO_API_PATH}/cms`;
  private readonly VITE_MAIA_API_PATH = `${import.meta.env.VITE_MAIA_API_PATH}`;

  private readonly endpoints = {
    baseUrl: this.BASE_CONFIG,
    apiUrl: this.API_URL,
    cmsUrl: this.CMS_URL,
    maiaPath: this.VITE_MAIA_API_PATH,
    customerUrl: `${this.API_URL}/customers`,
    insuranceUrl: `${this.API_URL}/insurances`,
    quotationUrl: `${this.API_URL}`,
    taskUrl: `${this.API_URL}/tasks`,
    claimUrl: `${this.API_URL}`,
    brokerUrl: `${this.API_URL}/brokers`,
    teamUrl: `${this.API_URL}/teams`,
    cartUrl: '',
    attachmentsUrl: `${this.API_URL}/attachments`,
    authorizationUrl: `${this.BASE_CONFIG}/${import.meta.env.VITE_AUTHROIZATION_PATH}`,
    AccessTokenUrl: `${this.BASE_CONFIG}${import.meta.env.VITE_TOKEN_PATH}`,
    authorizationCallbackUrl: import.meta.env.VITE_AUTH_CALLBACK_URL,
    cartApi: (cartGuid: string) => `${this.API_URL}/carts/${cartGuid}`,
    impersonateCustomer: (email: string) => `${this.VITE_MAIA_API_PATH}/api/customer/${encodeURIComponent(email)}/impersonate`,
    authUserCreate: `${this.VITE_MAIA_API_PATH}/api/auth/user`,
    authUserUpdate: (guid: string) => `${this.VITE_MAIA_API_PATH}/api/auth/user/${guid}`,
    authRefreshToken: `${this.VITE_MAIA_API_PATH}/api/auth/refresh`,
  } as const;

  private readonly defaultValues = {
    pageSize: 10,
  } as const;

  private readonly config = { ...this.endpoints, ...this.defaultValues };

  get<T extends keyof typeof this.config>(key: T): (typeof this.config)[T] {
    const value = this.config[key];
    if (value === undefined) {
      throw new Error(`No config found for ${key}`);
    }
    return value;
  }
}
